type TextInputProps = {
  id?: string;
  name: string;
  label: string;
  type?: 'text' | 'email' | 'password';
  autoComplete?: string;
  autoFocus?: boolean;
  inputMode?: 'numeric' | 'text';
  placeholder?: string;
  required?: boolean;
  minLength?: number;
  maxLength?: number;
  disabled?: boolean;
  value: string;
  onChange: (value: string) => void;
};

export function TextInput({
  id,
  name,
  label,
  type = 'text',
  autoComplete,
  autoFocus,
  inputMode,
  placeholder,
  required,
  minLength,
  maxLength,
  disabled,
  value,
  onChange,
}: TextInputProps) {
  return (
    <div>
      <label
        htmlFor={id ?? name}
        className="mb-2 block font-medium text-sm text-spark-text-primary"
      >
        {label}
      </label>
      <div className="relative">
        <input
          id={id ?? name}
          name={name}
          type={type}
          maxLength={maxLength}
          minLength={minLength}
          autoComplete={autoComplete}
          // biome-ignore lint/a11y/noAutofocus: intentionally using autoFocus for this input field
          autoFocus={autoFocus}
          inputMode={inputMode}
          placeholder={placeholder}
          required={required}
          value={value}
          disabled={disabled}
          className="block w-full appearance-none rounded-md border border-spark-border-default bg-spark-surface px-3 py-2 text-sm text-spark-text-primary placeholder-spark-text-tertiary shadow-xs transition focus:border-spark-accent-hover focus:outline-hidden focus:ring-spark-accent-hover disabled:bg-spark-surface-muted disabled:text-spark-text-secondary"
          onChange={(event) => onChange(event.target.value)}
        />
        {maxLength && (
          <div className="absolute inset-e-3 top-[9px] text-sm text-spark-text-secondary">
            {value.length}/{maxLength}
          </div>
        )}
      </div>
    </div>
  );
}
